import pace from 'pace-js/pace';

pace.start();